import type { IncomingHttpHeaders } from 'http';

export interface GetDeviceDetectsReturnType {
  isAndroid: () => boolean;
  isApple: () => boolean;
  isBot: () => boolean;
  isDesktop: () => boolean;
  isEdgeBrowser: () => boolean;
  isEdgeOrIE: () => boolean;
  isMobile: () => boolean;
  isIos: () => boolean;
  isSSR: () => boolean;
  isFirefox: () => boolean;
  isWindows: () => boolean;
  isOther: () => boolean;
  userAgent: string;
}

export const checkDeviceType = (userAgent = ''): GetDeviceDetectsReturnType => {
  if (!userAgent) {
    userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;
  }
  const isAndroid = (): boolean => Boolean(userAgent.match(/Android/i));
  const isApple = (): boolean => Boolean(userAgent.match(/iPhone|iPad|iPod|MacIntel|MacPPC|Mac68K|Macintosh/i));
  const isIos = (): boolean => Boolean(userAgent.match(/iPhone|iPad|iPod/i));
  const isWindows = (): boolean => Boolean(userAgent.match(/Windows|Win32|Win64|WinCE|IEMobile/i));
  const isOperaMini = (): boolean => Boolean(userAgent.match(/Opera Mini/i));
  const isMobile = (): boolean => Boolean(userAgent.match(/Mobile/i) || isAndroid() || isIos() || isOperaMini());
  const isDesktop = (): boolean => Boolean(!isMobile() && !isSSR() && !isOther());
  const isSSR = (): boolean => Boolean(userAgent.match(/SSR/i));
  const isEdgeBrowser = (): boolean => Boolean(userAgent.match(/Edge/i));
  const isFirefox = (): boolean => Boolean(userAgent.match(/Firefox|FxiOS/i));
  const isEdgeOrIE = (): boolean => Boolean(userAgent.match(/Trident|MSIE|Edge/i));
  const isOther = (): boolean => Boolean(userAgent.match(/Google-HTTP-Java-Client/i));
  const isBot = (): boolean =>
    Boolean(
      userAgent.match(/Bot|Googlebot|GoogleOther|Google-InspectionTool|Crawler|Robot|Slurp|Baiduspider|Mediapartners/i),
    );

  return {
    isAndroid,
    isApple,
    isBot,
    isDesktop,
    isEdgeBrowser,
    isEdgeOrIE,
    isFirefox,
    isIos,
    isMobile,
    isOther,
    isSSR,
    isWindows,
    userAgent,
  };
};

export type DeviceType = 'mobile' | 'desktop' | 'SSR' | 'bot' | 'unknown';

export const getDeviceTypeFromUserAgent = (userAgent: string): DeviceType => {
  if (typeof userAgent !== 'string') return 'unknown';
  if (userAgent === 'mobile') return 'mobile';
  if (userAgent === 'desktop') return 'desktop';
  const device = checkDeviceType(userAgent);
  if (device.isBot()) return 'bot';
  if (device.isMobile()) return 'mobile';
  if (device.isDesktop()) return 'desktop';
  if (device.isSSR()) return 'SSR';
  return 'unknown';
};
export interface DeviceInfo {
  deviceType: DeviceType | null;
  userAgent: string | null;
}

export const getDeviceInfoFromRequestHeaders = (
  headers: IncomingHttpHeaders,
  cookies?: Partial<{
    [key: string]: string;
  }>,
): DeviceInfo => {
  if (!headers) {
    return {
      deviceType: null,
      userAgent: null,
    };
  }

  const userAgent = headers?.['user-agent'] || null;

  let deviceType: DeviceType | null = null;

  if (cookies?.['device_type']) {
    deviceType = cookies['device_type'] as DeviceType;
  }

  // if (headers && headers['x-client-is-mobile'] && headers['x-client-is-mobile'] !== '' && !deviceType) {
  //   deviceType = headers['x-client-is-mobile'] === '1' ? 'mobile' : 'desktop';
  // }

  if (userAgent && !deviceType) {
    deviceType = getDeviceTypeFromUserAgent(userAgent);
  }

  return {
    deviceType,
    userAgent,
  };
};
